import styled from "@emotion/styled"
import { NewTextProps, extractProperty } from "ui"

import { Divider } from "@mui/material"
import { Fragment } from "react"
import AccordionItem from "./AccordionItem"


const StyledDivider = styled(Divider)`
  background-color: ${(props) => props.theme.colors.gray};
`


export type Accordion = {
  accordionTitle: string,
  accordionContent: string
}

const mapperToAccordion = (data: any[], titleProp: string, contentProp: string): Accordion[] => {
  return data.map(item => {
    const accordionTitle = extractProperty(item, titleProp)
    const accordionContent = extractProperty(item, contentProp)
    return {
      accordionTitle,
      accordionContent
    }
  })
}
type Props = {
  accordion: any[],
  titleProp: string,
  contentProp: string,
  titleOverrideStyle?: Partial<NewTextProps>,
  contenrOverrideStyle?: Partial<NewTextProps>,
  arrowIconSize?: number
}
function AccordionFaq({ accordion, titleProp, contentProp, titleOverrideStyle, contenrOverrideStyle, arrowIconSize = 40 }: Props) {
  const currentData = mapperToAccordion(accordion, titleProp, contentProp)
  return (
    <>
      {currentData.map((item, index: number) => (
        <Fragment key={index}>
          <AccordionItem
            index={index}
            accordionTitle={item.accordionTitle}
            accordionContent={item.accordionContent}
            titleOverrideStyle={titleOverrideStyle}
            contenrOverrideStyle={contenrOverrideStyle}
            arrowIconSize={arrowIconSize}
            />
          <StyledDivider aria-hidden/>
        </Fragment>
      ))}
    </>
  )}
export default AccordionFaq